import {
  getCenterDetail,
  getInvoiceDetailsById,
  getInvoiceHistory,
  getPatientDetail,
  getPrintDetails,
  saveFinalInvoice, checkPaytmPaymentStatus
} from "core/services/api"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import PedigreeView from "pages/PatientClinicalView/components/GeneticCounsellor/components/PedigreeView/PedigreeView"
import React, { useEffect, useRef, useState } from "react"
import Button from "react-bootstrap/esm/Button"
import Toast from "components/Toast"
import { useHistory, useLocation, useParams } from "react-router"
import PaymentRows from "./PaymentRows"
import "./Payments.scss"
import FileUploadIcon from "@mui/icons-material/FileUpload"
import PrintBillDesk from "../printInvoice/PrintBillDesk"
import Table from "react-bootstrap/esm/Table"
import PrintAP from "../printInvoice/PrintAP"
import PrintSD from "../printInvoice/PrintSD"
import Select from "react-select"
import InputField from "components/InputField"
import Print from "components/Print/Print"

function Payments() {
  //Latest Billing UI Changes
  const paymentsNewDropdown = [
    {
      label: "Adjust Advance Payment",
      value: "advancePayment",
    },
    {
      label: "Adjust Security Deposit",
      value: "securityDeposit",
    },
    {
      label: "Payment Modes",
      value: "paymentMode",
    },
  ]

  const [invoice, setInvoice] = useState<any>()
  const [invoiceHistory, setInvoiceHistory] = useState<any>([])
  const [paytmPaymentTransactionStatus, setPaytmPaymentTransactionStatus] = useState<any>()
  const [checkingTransactionStatusID, setCheckingTransactionStatusID] = useState<string | null>(null);
  const [paytmPaymentTransactionResponse, setPaytmPaymentTransactionResponse] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  //Setting up Payment type whether its advanace, security or other payment modes
  const [paymentType, setPaymentType] = useState<any>()
  const [paymentDropdown, setPaymentDropdown] = useState<any>({})
  //Advance Payment and Security Deposit Initial State
  const [amount, setamount] = useState<any>({
    advancePayment: 0,
    securityDeposit: 0,
  })
  //Claim number and approval amount
  const [claimNumberInvoice, setClaimNumberInvoice] = useState("")
  const [approvalAmountInvoice, setApprovalAmountInvoice] = useState("")
  const [trustName, setTrustName] = useState("")
  //Validation for advance Payment and Security Deposit
  const [errorMsgAP, setErrorMsgAP] = useState<any>(false)
  const [errorValsAP, setErrorValsAP] = useState<any>({})
  const [errorMsgSD, setErrorMsgSD] = useState<any>(false)
  const [errorValsSD, setErrorValsSD] = useState<any>({})
  const [payments, setpayments] = useState<any>({
    paymentDetails: [
      {
        transactionId: "",
        transactionAmt: 0,
        modeOfPayment: "",
        companyName: "",
        bankName: "",
        cardNumber: "",
        chequeNo: "",
        tpaName: "",
        remarks: "",
      },
    ],
  })
  //Documents
  const [docsPayment, setDocsPayment] = useState<any>([])
  const [patient, setPatient] = useState<any>({})
  const [appointmentId, setappointmentId] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [currentItem, setCurrent] = useState(0)
  const [invoicePrint, setInvoicePrint] = useState<any>()
  const [currentCenterDetails, setCurrentCenterDetails] = useState<any>();
  //Staus cehck states
  const [showCheckStatusModal, setShowCheckStatusModal] = useState<any>(false)
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [statusCheckComplete, setStatusCheckComplete] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<any>();

  const { invoiceId }: any = useParams()
  const { state }: any = useLocation()
  const componentRef: any = useRef<any>(null)
  const componentRefAp: any = useRef<any>()
  const componentRefSd: any = useRef<any>(null)
  const saveRef = useRef<any>(null);
  const history = useHistory()
  const currentCenter = sessionStorage.getItem("currentCenter")


  const errors: any = {}

  const validate = (values: any, type: any) => {
    const intValue = parseInt(values, 10) // Convert 'values' to an integer

    if (type == "SD") {
      if (intValue > invoice?.totalSecurityDeposit) {
        errors["balanceSD"] = "Insufficient Balance"
      }
      if (JSON.stringify(errors) === "{}") {
        setErrorMsgSD(false)
      }
      else {
        setErrorMsgSD(true)
        setErrorValsSD(errors)
      }
    }
    if (type == "AP") {
      if (intValue > invoice?.totalAdvancePayment) {
        errors["balanceAP"] = "Insufficient Balance"
      }
      if (JSON.stringify(errors) === "{}") {
        setErrorMsgAP(false)
      }
      else {
        setErrorMsgAP(true)
        setErrorValsAP(errors)
      }
    }
  }

  const addTablePaymentRows = () => {
    const paymentInput = {
      transactionId: "",
      transactionAmt: 0,
      modeOfPayment: "",
      bankName: "",
      companyName: "",
      cardNumber: "",
      chequeNo: "",
      tpaName: "",
      remarks: "",
    }
    const tempPaymentDetails = [...payments.paymentDetails, paymentInput]
    setpayments({ ...payments, paymentDetails: tempPaymentDetails })
  }

  const handlePaymentChange = (index: any, evnt: any) => {
    let name, value
    if (evnt.target === undefined) {
      name = evnt.label
      value = evnt.value
      const rowsPayment = [...payments.paymentDetails]
      rowsPayment[index]["modeOfPayment"] = value
      setpayments({ ...payments, paymentDetails: rowsPayment })
    } else {
      name = evnt.target.name
      value = evnt.target.value
      if (name === "transactionAmt") {
        const inputValue = value.trim();
        const numericRegex = /^[0-9]*\.?[0-9]*$/;
        if (numericRegex.test(inputValue) || inputValue === "") {
          const rowsPayment = [...payments.paymentDetails];
          rowsPayment[index]["transactionAmt"] = inputValue;
          setpayments({ ...payments, paymentDetails: rowsPayment });
        }
      } else {
        const rowsPayment = [...payments.paymentDetails];
        rowsPayment[index][name] = value;
        setpayments({ ...payments, paymentDetails: rowsPayment });
      }
    }
  }

  const deleteTablePaymentRows = (index: any) => {
    if (payments?.paymentDetails?.length > 1) {
      const rowsPayment = [...payments.paymentDetails]
      rowsPayment.splice(index, 1)
      setpayments({ ...payments, paymentDetails: rowsPayment })
    }
  }

  const saveInvoiceTransaction = () => {
    if ((invoice?.claimNumber === null || invoice?.claimNumber === '') && (invoice?.approvalAmount !== null && invoice?.approvalAmount !== '' && Number(invoice?.approvalAmount) !== 0)) {
      toggleDisplayToast({
        text: "Please enter Claim Number",
        type: "error",
      });
      return;
    }

    if ((invoice?.claimNumber !== null && invoice?.claimNumber !== '') && (invoice?.approvalAmount === null || invoice?.approvalAmount === '' || Number(invoice?.approvalAmount) === 0)) {
      toggleDisplayToast({
        text: "Please enter Approval Amount",
        type: "error",
      });
      return;
    }

    let temp = [...payments.paymentDetails];
    temp = temp.map(item => ({
      ...item,
      claimNumber: invoice?.claimNumber || '',
      approvalAmount: invoice?.approvalAmount || ''
    }));

    const modifiedPayment = { ...payments, paymentDetails: temp };

    var jsonData = {
      claimNumber: invoice?.claimNumber ? invoice?.claimNumber : '',
      trustName: trustName ? trustName : "",
      approvalAmount: invoice?.approvalAmount ? invoice?.approvalAmount : '',
      paidBySecurityDeposit: amount?.securityDeposit,
      paidByAdvancePayment: amount?.advancePayment,
      paymentDetails: paymentType?.value === "advancePayment" || paymentType?.value === "securityDeposit" ? [] : modifiedPayment?.paymentDetails,
      document: docsPayment,
      centerId: currentCenter
    }

    if (errorMsgSD) {
      toggleDisplayToast({
        text: "Insufficent Balance. Cannot Save Invoice ",
        type: "error",
      })
      return;
    }
    if (errorMsgAP) {
      toggleDisplayToast({
        text: "Insufficent Balance. Cannot Save Invoice ",
        type: "error",
      })
      return;
    }
    else {
      setTimeout(() => {
        saveFinalInvoice(jsonData, invoiceId)
          .then((res) => {
            setIsLoading(false)
            toggleDisplayToast({
              text: res?.isPayment ? "Invoice has been saved successfully" : "Invoice updated successfully",
              type: "success",
            })
          })
          .catch((err) => {
            console.error(err, "error message")
            setIsLoading(false)
            toggleDisplayToast({
              text: `${err?.response?.data?.message}`,
              type: "error",
            })
          })
      }, 100);
    }

    saveRef.current.blur()
  }

  function scroll() {
    const element = document.getElementById("patientBillingWrapper")
    if (element) {
      element.scrollIntoView({ behavior: "auto" })
    }
  }

  const checkStatusModalClose = () => {
    setShowCheckStatusModal(false);
    setStatusCheckComplete(false);
    setPaymentStatus(false);
    window.location.reload()
  }

  const getPaymentStatusText = (status: string): string => {
    const statusMap: { [key: string]: string } = {
      'PENDING': 'Payment Pending',
      'FAIL': 'Payment Failed',
      'SUCCESS': 'Payment Successful',
      'ACCEPTED_SUCCESS': 'Payment Accepted',
      'FAILED': 'Payment Failed'
    };

    return statusMap[status] || status;
  };

  const getStatusStyle = (status: string): React.CSSProperties => {
    switch (status) {
      case 'SUCCESS':
        return { color: 'green' };
      case 'FAIL':
      case 'FAILED':
        return { color: 'red' };
      case 'PENDING':
      case 'ACCEPTED_SUCCESS':
        return { color: 'orange' };
      default:
        return {};
    }
  };

  const checkPaymentStatus = (paymentTransactionId: any): () => void => {
    setCheckingTransactionStatusID(paymentTransactionId);
    checkPaytmPaymentStatus(paymentTransactionId)
      .then((res: any) => {
        setPaytmPaymentTransactionResponse(res?.data);
        setCheckingTransactionStatusID(null);
        if (res?.data?.resultStatus === "SUCCESS" || res?.data?.resultCode === "0000") {
          window.location.reload();
        }
      })
      .catch((err) => {
        setCheckingTransactionStatusID(null);
      })

    return () => {
      setCheckingTransactionStatusID(null);;
    };
  }

  const getPaytmStatusMessage = (resultCode: string, resultStatus: string, resultMsg: string): string => {
    const statusMap: { [key: string]: string } = {
      '0010': 'Please check status on machine',
      '0012': 'Internal Server Error. Please retry',
      '0030': 'Please check the status on EDC machine',
      '0330': 'Invalid checksum',
      '0404': 'Transaction failed/declined',
      '0011': 'Transaction failed',
      '0000': 'Success',
      '0009': 'Payment request accepted',
      '0090': 'ECR void failed',
      '0180': 'VOID transaction not found'
    };

    return statusMap[resultCode] || resultMsg || 'Unknown status';
  };

  const checkPaymentStatusInsideModal = (paymentTransactionId: any) => {
    setCheckingStatus(true);
    setShowCheckStatusModal(true);
    setStatusCheckComplete(false);
    setPaymentStatus(false);

    let attempts = 0;
    const maxAttempts = 12;
    const intervalTime = 5000;

    const checkStatus = async () => {
      try {
        setIsLoading(true);
        const res = await checkPaytmPaymentStatus(paymentTransactionId);
        setIsLoading(false);

        // Update transaction status
        setPaytmPaymentTransactionStatus(res?.data);

        const { resultCode, resultStatus, resultMsg, transactionAmount, merchantTransactionId } = res?.data || {};
        const statusMessage = getPaytmStatusMessage(resultCode, resultStatus, resultMsg);

        // Check response status
        if (resultStatus === "SUCCESS" || resultCode === "0000") {
          setPaymentStatus({ text: `Payment Successful: ₹${(Number(transactionAmount || 0) / 100).toFixed(2)} Transaction ID: ${merchantTransactionId}`, status: resultStatus });
          setStatusCheckComplete(true);
          setCheckingStatus(false);
          return true; // Stop checking on success
        } else if (resultStatus === "FAIL" || resultStatus === "FAILED" ||
          ["0011", "0330", "0404", "0090", "0180"].includes(resultCode)) {
          setPaymentStatus({ text: `Status check failed: ${statusMessage}`, status: resultStatus });
          setStatusCheckComplete(true);
          setCheckingStatus(false);
          toggleDisplayToast({
            text: `Status check failed: ${statusMessage}`,
            type: "error",
          });
          return true; // Stop checking on failure
        } else if (resultStatus === "PENDING" || ["0010", "0030"].includes(resultCode)) {
          setPaymentStatus({ text: `${statusMessage}`, status: resultStatus });
          return false; // Continue checking
        } else if (resultStatus === "ACCEPTED_SUCCESS" || resultCode === "0009") {
          setPaymentStatus({ text: 'Payment request accepted', status: resultStatus });
          setStatusCheckComplete(true);
          setCheckingStatus(false);
          return true;
        }

        return false;
      } catch (err) {
        setIsLoading(false);
        console.error("Payment status check failed:", err);
        toggleDisplayToast({
          text: "Error checking payment status",
          type: "error",
        });
        return false;
      }
    };

    const timer = setInterval(async () => {
      attempts++;

      const shouldStop = await checkStatus();

      if (shouldStop || attempts >= maxAttempts) {
        clearInterval(timer);

        if (!shouldStop) {
          setPaymentStatus({ text: 'Payment Status Check Timeout', status: "ACCEPTED_SUCCESS" });
        }

        setStatusCheckComplete(true);
        setCheckingStatus(false);
      }
    }, intervalTime);

    checkStatus();

    return () => {
      clearInterval(timer);
      setCheckingStatus(false);
      setIsLoading(false);
    };
  };

  useEffect(() => {
    let cleanup: (() => void) | null = null;
    if (showCheckStatusModal && paytmPaymentTransactionStatus?.id) {
      cleanup = checkPaymentStatusInsideModal(paytmPaymentTransactionStatus.id);
    }

    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, [showCheckStatusModal]);

  useEffect(() => {
    scroll()
  }, [])

  useEffect(() => {
    if (invoice?.id) {
      getPrintDetails(invoice?.id)
        .then((res) => {
          setInvoicePrint(res)
        })
        .catch((err) => {
          console.error(err, "error")
        })
    }

    if (invoice?.patientId) {
      getPatientDetail(invoice?.patientId)
        .then((res: any) => {
          setPatient(res)
        })
        .catch((err: any) => {
          console.error("err", err)
        })
    }
  }, [invoice])

  useEffect(() => {
    getCenterDetail(currentCenter)
      .then((res: any) => {
        setCurrentCenterDetails(res);
      })
      .catch((err) => {
        console.error("Failed to fetch center detail", err)
      })
  }, [currentCenter])


  useEffect(() => {
    getInvoiceDetailsById(invoiceId)
      .then((res) => {
        setInvoice(res)
        const { document } = res
        setDocsPayment(document?.length > 0 ? document : [])
      })
      .catch((error) => {
        console.error(error)
      })
    if (invoiceId) {
      getInvoiceHistory(invoiceId)
        .then((res) => {
          setInvoiceHistory(res)
        })
        .catch((error: any) => {
          console.error(error)
        })
    }
  }, [paytmPaymentTransactionResponse, showCheckStatusModal])


  useEffect(() => {
    if (paymentType?.value === "paymentMode") {
      setErrorMsgAP(false);
      setErrorValsSD(false)
    }
  }, [paymentType])

  return (
    <div className="payments-wrapper" id="patientBillingWrapper">
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      {/* Section 1 */}
      <div className="top-heading-wrapper">
        <div className="invoice-heading-container">
          <div
            className="approval-back-image"
            onClick={() => {
              history.goBack()
            }}
          >
            <img
              src={"../../../../assets/images/back-icon.svg"}
              alt="back button"
              className="image-top-wrapper"
            />
          </div>
          <div className="Heading-Billing">
            Invoice : {moment(invoice?.appointmentDate).format("DD-MM-YYYY")}
          </div>
          <div className="subHeading-Billing">
            {invoice?.isVip ? (
              <>
                <div>***Masked***</div>
              </>
            ) : (
              <>{invoice?.patientName}</>
            )}{" "}
            &nbsp; ({invoice?.mocPatientId})&nbsp;{invoice?.appointmentType} &nbsp;
            &nbsp;
            {invoice?.mocAppointmentId}
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="security-advance-container">
          <div className="subheading-payment">Available Security Deposit:</div>
          <div className="subheading-value">
            {invoice?.totalSecurityDeposit?.toFixed(2)}
          </div>
          <div className="subheading-payment">Available Advance Payment:</div>
          <div className="subheading-value">
            {invoice?.totalAdvancePayment?.toFixed(2)}
          </div>
          <img
            className="image-top-wrapper"
            src={"../../../../assets/images/Money.svg"}
          />
        </div>
        <div style={{ marginTop: "auto" }}>
          <Button className="common-button">
            Pending Bills Due-{invoice?.patientPendingAmount?.toFixed(2)}
          </Button>
        </div>
      </div>

      <section className="treatments-and-products-wrapper">
        <div
          className="Heading-Billing"
          id="payment-heading"
          style={{ color: "blue", margin: "auto", fontSize: "30px !important" }}
        >
          Invoice Details
        </div>

        <hr />
        <section className="total-amount-payable">
          <div className="subheading-total-amount">
            Net Invoice Amount: &nbsp; &nbsp;
          </div>
          <div className="subheading-value">
            {state?.totalPayable?.toFixed(2)}
          </div>
          <div className="subheading-total-amount">
            Balance After Payment: &nbsp; &nbsp;
          </div>
          <div className="subheading-value">
            {(Math.floor(invoice?.pendingAmount * 100) / 100)?.toFixed(2)}
          </div>
        </section>

        <hr />
        <section className="claim-number">
          <div className="subheading-total-amount">
            Claim number: &nbsp; &nbsp;
          </div>
          <div className="subheading-value">
            <InputField
              placeholder="Claim number"
              handleChange={(e) => {
                setClaimNumberInvoice(e.target.value)
                const valueInv = { ...invoice }
                valueInv.claimNumber = e.target.value
                setInvoice(valueInv)
              }}
              value={invoice?.claimNumber}
            />
          </div>
          <div className="subheading-total-amount">
            Approval amount: &nbsp; &nbsp;
          </div>
          <div className="subheading-value">
            <InputField
              // type="number"
              placeholder="Approval amount"
              handleChange={(e: any) => {
                const value = e.target.value
                let res = ""
                if (value) {
                  value?.split("")?.forEach((ele: any) => {
                    let k = ele?.charCodeAt(0)
                    if (k >= 48 && k <= 57) {
                      res += ele
                    }
                  })
                }
                if (res) {
                  setApprovalAmountInvoice(res)
                  const valueInv = { ...invoice }
                  valueInv.approvalAmount = res
                  setInvoice(valueInv)
                } else {
                  setApprovalAmountInvoice("")
                  const valueInv = { ...invoice }
                  valueInv.approvalAmount = ""
                  setInvoice(valueInv)
                }
              }}
              value={invoice?.approvalAmount}
            />
          </div>
        </section>

        <hr />
        <section className="upload-documents">
          <div
            className="Heading-Billing"
            style={{
              display: "flex",
              alignItems: "center",
              width: "400px",
            }}
            id="payment-heading"
          >
            {" "}
            <img
              className="image-top-wrapper"
              src={"../../../../assets/images/Money.svg"}
            />
            Payments
            <span className="payments-new-dropdown">
              {" "}
              <Select
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    border: "1px solid #ccd0e7",
                    borderRadius: "10px"
                  })
                }}
                className="select-payment"
                name="modeOfPayment"
                options={paymentsNewDropdown}
                value={paymentType}
                onChange={(evnt: any) => {
                  setamount({
                    advancePayment: 0,
                    securityDeposit: 0,
                  })

                  setPaymentType({
                    label: evnt?.label,
                    value: evnt?.value
                  })

                }}
              />
            </span>
          </div>
        </section>
        <div className="col-sm-12 table-bill">
          <div className="Heading-Billing-payment-mode" id="payment-heading" style={{
            marginLeft: '40px', fontSize: '20px'
          }}>
            {paymentType?.value == "advancePayment" ? (
              <>Adjust Advance Payment</>
            ) : paymentType?.value == "securityDeposit" ? (
              <>Adjust Security Deposit</>
            ) : paymentType?.value == "paymentMode" ? (
              <></>
            ) : (
              <></>
            )}
          </div>

          <div>
            {paymentType?.value == "advancePayment" ? (
              <>
                <input
                  type="text"
                  className="form-control-width"
                  name="advancePayment"
                  value={amount.advancePayment}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;
                    const numericRegex = /^[0-9]*\.?[0-9]*$/;
                    if (numericRegex.test(inputValue)) {
                      setamount({
                        ...amount,
                        advancePayment: inputValue,
                      });
                    } else {
                      setamount({
                        ...amount,
                        advancePayment: "",
                      });
                    }
                    validate(inputValue, "AP");
                  }}
                />
                {errorMsgAP ? (
                  <div className="errorMsg">{errorValsAP.balanceAP}</div>
                ) : (
                  <div className="errorMsg"></div>
                )}
              </>
            ) : paymentType?.value == "securityDeposit" ? (
              <>
                <input
                  type="text"
                  className="form-control-width"
                  name="securityDeposit"
                  value={amount.securityDeposit}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;
                    const numericRegex = /^[0-9]*\.?[0-9]*$/;
                    if (numericRegex.test(inputValue)) {
                      setamount({
                        ...amount,
                        securityDeposit: inputValue,
                      });
                    } else {
                      setamount({
                        ...amount,
                        securityDeposit: "0",
                      });
                    }
                    validate(e.target.value, "SD");
                  }}
                />

                {errorMsgSD ? (
                  <div className="errorMsg">{errorValsSD.balanceSD}</div>
                ) : (
                  <div className="errorMsg"></div>
                )}
              </>
            ) : paymentType?.value == "paymentMode" ? (
              <>
                {" "}
                <PaymentRows
                  invoice={invoice}
                  paymentDetails={
                    payments.paymentDetails ? payments.paymentDetails : []
                  }
                  deleteTableRows={deleteTablePaymentRows}
                  handlePaymentChange={handlePaymentChange}
                  addTablePaymentRows={addTablePaymentRows}
                  setPaymentType={setPaymentType}
                  setTrustName={setTrustName}
                  trustName={trustName}
                  setShowCheckStatusModal={setShowCheckStatusModal}
                  setPaytmPaymentTransactionCallBack={(res: any) => {
                    setPaytmPaymentTransactionStatus(res?.data)
                    setShowCheckStatusModal(true)
                  }
                  }
                />
              </>
            ) : (
              <></>
            )}
          </div>

          <div className="upload-documents-billing">
            {" "}
            <section className="upload-documents">
              <div className="Heading-Billing" id="payment-heading">
                {/* <UploadFileIcon className='uploadIcon' /> */}
                <FileUploadIcon className="uploadIcon" />
                Upload Documents
              </div>
              <PedigreeView
                docs={docsPayment}
                patient={patient}
                type={"BookAppointment"}
                appointmentId={appointmentId}
                uploadDocument={(documents: any) => {
                  setDocsPayment([...docsPayment, ...documents])
                }}
              />
            </section>
          </div>
          <div className="save">
            <Button ref={saveRef} className="common-button" onClick={saveInvoiceTransaction} disabled={
              (((claimNumberInvoice === "" || claimNumberInvoice === null) && (Number(approvalAmountInvoice) === 0 || approvalAmountInvoice === "")) ||
                ((invoice?.claimNumber === '' || invoice?.claimNumber === null) ?
                  (((claimNumberInvoice !== "" || claimNumberInvoice !== null) && (Number(approvalAmountInvoice) === 0 || approvalAmountInvoice === ""))
                    || ((claimNumberInvoice === '' || claimNumberInvoice === null) && Number(approvalAmountInvoice) !== 0))
                  : Number(invoice?.approvalAmount) === 0 ?
                    (((claimNumberInvoice !== "" || claimNumberInvoice !== null) && (Number(approvalAmountInvoice) === 0 || approvalAmountInvoice === ""))
                      || ((claimNumberInvoice === '' || claimNumberInvoice === null) && Number(approvalAmountInvoice) !== 0))
                    : false))
              && (paymentType === undefined || (paymentType?.value === "advancePayment" && Number(amount?.advancePayment) === 0) || (paymentType?.value === "securityDeposit" && Number(amount?.securityDeposit) === 0) || (paymentType?.value === "paymentMode" && payments?.paymentDetails?.[0]?.modeOfPayment === "" && Number(payments?.paymentDetails?.[0]?.transactionAmt) !== 0) || (paymentType?.value === "paymentMode" && payments?.paymentDetails?.[0]?.modeOfPayment !== "" && Number(payments?.paymentDetails?.[0]?.transactionAmt) === 0) || (paymentType?.value === "paymentMode" && payments?.paymentDetails?.[0]?.modeOfPayment === "" && Number(payments?.paymentDetails?.[0]?.transactionAmt) === 0) || (paymentType?.value === "paymentMode" && payments?.paymentDetails?.[0]?.modeOfPayment === "POS MACHINE"))}>
              Save Invoice
            </Button>

            <Print
              componentRef={componentRef}
              buttonTitle="Print Invoice"
            />
            <PrintBillDesk
              printRef={componentRef}
              invoice={invoice && invoice}
              currentCenter={currentCenterDetails}
              patient={patient}
            />
          </div>
          <hr />


          {/* Paytm transaction history */}
          <div>
            <section className="upload-documents">
              <div className="Heading-Billing" id="payment-heading">
                <img
                  className="image-top-wrapper"
                  src={"../../../../assets/images/Money.svg"}
                />
                Paytm Transaction History
              </div>

              <div
                style={{
                  width: "99%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "20px",
                }}
              >
                <div>
                  <Table id="tablePreview" bordered hover>
                    <thead style={{ backgroundColor: "#E1E3EF" }}>
                      <tr>
                        <th>Transaction Id</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Date & Time</th>
                        <th>Status Date & Time</th>
                        <th>Transaction Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    {invoiceHistory?.paytmTransactionHistory?.map((val: any, i: any) => {
                      return (
                        <>
                          <tbody>
                            <tr>
                              <td>{val?.merchantTransactionId}</td>
                              <td>{(Number(val?.transactionAmount || 0) / 100).toFixed(2)}</td>
                              <td>
                                {moment(val?.transactionDateTime).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                &nbsp; &nbsp;
                                {moment(val?.transactionDateTime).format(
                                  "h:mm:ss a"
                                )}{" "}
                              </td>
                              <td>
                                {moment(val?.statusCheckTimestamp).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                &nbsp; &nbsp;
                                {moment(val?.statusCheckTimestamp).format(
                                  "h:mm:ss a"
                                )}{" "}
                              </td>
                              <td style={getStatusStyle(val?.resultStatus)}>
                                {getPaymentStatusText(val?.resultStatus)}
                              </td>
                              <td>
                                {(() => {
                                  const isFinalStatus = ["SUCCESS", "FAIL", "FAILED"].includes(val?.resultStatus);

                                  if (!isFinalStatus) {
                                    return (
                                      <Button
                                        variant="primary"
                                        className="submission-button"
                                        style={{ minWidth: 150 }}
                                        disabled={checkingTransactionStatusID === val?.id}
                                        onClick={() => checkPaymentStatus(val?.id)}
                                      >
                                        {checkingTransactionStatusID === val?.id ?
                                          <div
                                            style={{ width: "1rem", height: "1rem" }}
                                            className="spinner-border text-secondary"
                                          />
                                          : "Check Status"}
                                      </Button>
                                    );
                                  }

                                  return null;
                                })()}
                              </td>
                            </tr>
                          </tbody>
                        </>
                      )
                    })}
                  </Table>
                </div>
              </div>
            </section>
          </div>

          <div
            className="Heading-Billing"
            id="payment-heading"
            style={{
              color: "blue",
              margin: "auto",
              fontSize: "30px !important",
            }}
          >
            Payment History
          </div>
          <hr />

          <div>
            {" "}
            <section className="upload-documents">
              <div className="Heading-Billing" id="payment-heading">
                {" "}
                <img
                  className="image-top-wrapper"
                  src={"../../../../assets/images/Money.svg"}
                />
                Payments History
              </div>

              <div
                style={{
                  width: "99%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "20px",
                }}
              >
                <div>
                  <Table id="tablePreview" bordered hover>
                    <thead style={{ backgroundColor: "#E1E3EF" }}>
                      <tr>
                        <th>Receipt Id</th>
                        <th>Mode of Payment</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Date & Time</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>

                    {invoiceHistory?.paymentHistory?.map((val: any, i: any) => {
                      return (
                        <>
                          <tbody>
                            <tr>
                              <td>{val?.mocReceiptId}</td>
                              <td>{val?.modeOfPayment}</td>
                              <td style={{ textAlign: "left" }}>
                                {val?.transactionAmount?.toFixed(2)}
                              </td>
                              <td>
                                {moment(val?.transactionDateTime).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                &nbsp; &nbsp;
                                {moment(val?.transactionDateTime).format(
                                  "h:mm:ss a"
                                )}{" "}
                              </td>
                              <td>{val?.remarks}</td>
                            </tr>
                          </tbody>
                        </>
                      )
                    })}
                  </Table>
                </div>
              </div>
            </section>
          </div>

          <div>
            {" "}
            <section className="upload-documents">
              <div className="Heading-Billing" id="payment-heading">
                {" "}
                <img
                  className="image-top-wrapper"
                  src={"../../../../assets/images/Money.svg"}
                />
                Advance Payment History
              </div>

              <div
                style={{
                  width: "99%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "20px",
                }}
              >
                <div>
                  <Table id="tablePreview" bordered hover>
                    <thead style={{ backgroundColor: "#E1E3EF" }}>
                      <tr>
                        <th>Receipt Id</th>
                        <th>Mode of Payment</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Date & Time</th>
                        <th></th>
                      </tr>
                    </thead>

                    {invoiceHistory?.advanceHistory?.map((val: any, i: any) => {
                      return (
                        <>
                          <tbody>
                            <tr>
                              <td>{val?.mocReceiptId}</td>
                              <td>{val?.modeOfPayment}</td>
                              <td style={{ textAlign: "left" }}>
                                {val?.transactionAmount?.toFixed(2)}
                              </td>
                              <td>
                                {moment(val?.transactionDateTime).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                &nbsp; &nbsp;
                                {moment(val?.transactionDateTime).format(
                                  "h:mm:ss a"
                                )}
                              </td>
                              <td>
                                {
                                  invoice && Object.keys(invoice)?.length === 0 ?
                                    null
                                    :
                                    <PrintAP
                                      printRef={
                                        currentItem === i ? componentRefAp : null
                                      }
                                      invoice={invoicePrint}
                                      documentTitle={val?.mocReceiptId}
                                      index={val?.mocReceiptId}
                                      invoiceHistory={invoiceHistory}
                                      patient={patient}
                                    />
                                }
                                <Print
                                  componentRef={componentRefAp}
                                  documentTitle={val?.mocReceiptId}
                                  onBeforeGetContent={async () => {
                                    setCurrent(i)
                                    await new Promise((r) =>
                                      setTimeout(r, 1000)
                                    )
                                  }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </>
                      )
                    })}
                  </Table>
                </div>
              </div>
            </section>
          </div>

          <div>
            {" "}
            <section className="upload-documents">
              <div className="Heading-Billing" id="payment-heading">
                {" "}
                <img
                  className="image-top-wrapper"
                  src={"../../../../assets/images/Money.svg"}
                />
                Security Deposit History
              </div>

              <div
                style={{
                  width: "99%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginTop: "20px",
                }}
              >
                <div>
                  <Table id="tablePreview" bordered hover>
                    <thead style={{ backgroundColor: "#E1E3EF" }}>
                      <tr>
                        <th>Receipt Id</th>
                        <th>Mode of Payment</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Date & Time</th>
                        <th></th>
                      </tr>
                    </thead>

                    {invoiceHistory?.securityDepositHistory?.map(
                      (val: any, i: any) => {
                        if (val?.transactionAmount > 0) {
                          return (
                            <tbody key={i}>
                              <tr>
                                <td>{val?.mocReceiptId}</td>
                                <td style={{ textAlign: "left" }}>
                                  {val?.modeOfPayment}
                                </td>
                                <td>{val?.transactionAmount?.toFixed(2)}</td>
                                <td>
                                  {moment(val?.transactionDateTime).format(
                                    "DD-MM-YYYY"
                                  )}{" "}
                                  &nbsp; &nbsp;
                                  {moment(val?.transactionDateTime).format(
                                    "h:mm:ss a"
                                  )}
                                </td>
                                <td>

                                  {
                                    invoice && Object.keys(invoice)?.length === 0 ?
                                      null
                                      :
                                      <PrintSD
                                        printRef={
                                          currentItem === i ? componentRefSd : null
                                        }
                                        invoice={invoicePrint}
                                        invoiceHistory={invoiceHistory}
                                        documentTitle={val?.mocReceiptId}
                                        index={val?.mocReceiptId}
                                        patient={patient}
                                      />
                                  }
                                  <Print
                                    componentRef={componentRefSd}
                                    documentTitle={val?.mocReceiptId}
                                    onBeforeGetContent={async () => {
                                      setCurrent(i)
                                      await new Promise((r) =>
                                        setTimeout(r, 1000)
                                      )
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          )
                        }
                        return null
                      }
                    )}
                  </Table>
                </div>
              </div>
            </section>
          </div>
        </div >
      </section >
      <div className="save"></div>

      <Modal
        show={showCheckStatusModal}
        onHide={() => {
          checkStatusModalClose()
        }}
      >
        <Modal.Header className="d-flex flex-row justify-content-center">
          <Modal.Title>
            Processing Payment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-between align-items-center" style={{ minHeight: '100px', gap: '10px', lineHeight: '1.8rem' }}>
            {!statusCheckComplete && checkingStatus && (
              <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ gap: '10px', color: 'orange' }}>
                <div> Transaction ID: {paytmPaymentTransactionStatus?.merchantTransactionId} </div>
                <div>Amount: {`₹${(Number(paytmPaymentTransactionStatus?.transactionAmount || 0) / 100).toFixed(2)}`}</div>
                <div
                  style={{ width: "2rem", height: "2rem", }}
                  className="spinner-border text-primary"
                ></div>
              </div>
            )}

            {statusCheckComplete && (
              <div style={{ textAlign: 'center', padding: '20px', lineHeight: '1.8rem' }}>
                <span style={getStatusStyle(paymentStatus?.status)}>{paymentStatus?.text}</span>
              </div>
            )}

            <div>
              <Button
                type="button"
                onClick={() => {
                  checkStatusModalClose()
                }}
                id="cancel"
              >
                Close
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {
        displayToast && (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              toggleDisplayToast(false)
              setShowCheckStatusModal(false)
              if (displayToast?.type === "success") {
                window.location.reload()
              }
            }}
            onCloseText="Close"
            onClickText={null}
          />
        )
      }
    </div >
  )
}

export default Payments
